import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import NewsieTakeawayPointsEditor from "./NewsieTakeawayPointsEditor";
import { makeSavePuzzleRequest } from "API/Puzzles";
import NewsieEditor from "./UploadContentNewsie";
import "./ManagePublicationNewsies.css";
import { flipArray, transpose } from "Util/validation";

const CreateNewsiePage = (props) => {
  const { onClickBack, draftNewsie, puzzleTitle } = props;
  const [file, setFile] = useState();
  const dispatch = useDispatch();

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };

  function handleSubmit(event) {
    event.preventDefault();
  }

  const puzzle = useSelector(
    (state) => state.puzzleSlice.puzzle || draftNewsie
  );

  const puzzleId = useSelector((state) => state.puzzleSlice.puzzleId);

  const authToken = useSelector((state) => state.authSlice.authToken);

  const organization = useSelector(
    (state) => state.clientProfileSlice.organization
  );

  const handleSaveNewsie = useCallback(async () => {
    const draftPuzzle = {
      ...puzzle,
      newsieInput: flipArray(puzzle?.newsieInput),
    };
    const savePuzzleParam = {
      id: puzzleId,
      title: puzzleTitle,
      puzzle: draftPuzzle,
      puzzleType: "newsie",
    };
    await makeSavePuzzleRequest(dispatch, authToken, savePuzzleParam);
  }, [dispatch, puzzleTitle, authToken, puzzle, puzzleId]);

  return (
    <>
      <div className="create-games-topbar-container">
        <div className="create-games-topbar-back-button" onClick={onClickBack}>
          <b>{"< "}</b>Back
        </div>{" "}
        <div
          className="create-games-topbar-continue-button"
          name='save-puzzle'
          onClick={handleSaveNewsie}
        >
          Save<b>{" >"}</b>
        </div>
      </div>
      <div className="manage-newsie-dashboard">
        <NewsieTakeawayPointsEditor selectedNewsie={puzzle} />
        <NewsieEditor selectedNewsie={puzzle} />
      </div>
    </>
  );
};

export default CreateNewsiePage;
